import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';

import { CollapseCheckbox } from '../components/collapseCheckbox';
import { KjelVannbarenVarme } from '../components/kjelVannbarenVarme';
import { AboutFormControlProps } from '../../types';
import { JaNeiVetIkke, OppvarmingBruk, Varmesentral } from '../../../../../utils/registerEnums';

const biokjelDefaultValue = {
  serviceGjennomfortSiste2Ar: JaNeiVetIkke.VetIkke,
  varmesentral: Varmesentral.Ukjent,
  bruk: OppvarmingBruk.Ukjent
};

export const BiokjelField: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  return (
    <Controller
      name="oppvarming.oppvarmingBioenergi.kjel.selected"
      control={control}
      render={({ field, fieldState }) => {
        return (
          <CollapseCheckbox
            labelKey="register.tekniskUtstyr.bioKjel.label"
            checked={!!field.value}
            onChange={(checked) => {
              field.onChange(checked);

              const newValue = checked ? biokjelDefaultValue : undefined;

              setValue('oppvarming.oppvarmingBioenergi.kjel.value', newValue);
            }}
            error={!!fieldState.error}
          >
            <KjelVannbarenVarme name="oppvarming.oppvarmingBioenergi.kjel.value" control={control} />
          </CollapseCheckbox>
        );
      }}
    />
  );
};
